import React, { useEffect } from 'react';
import Data from '../../Data/Data.json';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import PageNotFound from '../../Pages/PageNotFound';
import formatNumber from '../../Functions/Traitement/FormatNumber';
import { Backspace, Print } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png";
import i18next from 'i18next';
import formatOrderDate from '../../Functions/Traitement/formatOrderDate';
import { CONTRACT_TYPES, ContractCategory } from '../Forms/Financement/Quard/Contrat/ContractTypes';

const PrintContratIslamique = () => {
  const [contractData, setContractData] = React.useState(
    localStorage.getItem(Data.LocalVariable.tabAmort) 
      ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabAmort) + "") 
      : null as any
  );
  const navigate = useNavigate();
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));

  useEffect(() => {
    if (contractData == null) {
      navigate("/financement/quard/contrat");
    }
  }, []);

  const contractTypeInfo = contractData?.contractCode 
    ? CONTRACT_TYPES[contractData.contractCode as ContractCategory] 
    : null;

  return (
    <div>
      <br />
      {contractData ? (
        <>
          <Box className='backBtnt' onClick={() => { navigate(-1) }}>
            <Backspace />
          </Box>
          <Box className={"preview_print"}>
            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
              <img className='printLogo' src={Logo} width={80} />
              
              <Typography className='textTitle'>
                <b>CONTRAT DE FINANCEMENT ISLAMIQUE</b>
              </Typography>
              
              <hr className='hide' />
              <Button 
                title='Imprimer ( ctrl + p )' 
                onClick={() => { window.print() }} 
                icon={<Print />} 
                size='large' 
                className='bt_add' 
                type="ghost" 
                htmlType="button" 
                block
              />
            </Box>
            <br />

            {/* Header Section */}
            <Box className='contract-header'>
              <Typography variant="h6" align="center" style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                CONTRAT DE FINANCEMENT CONFORME À LA SHARIA
              </Typography>
              <Typography variant="body1" align="center" style={{ marginBottom: '20px' }}>
                Au nom de Dieu, le Tout Miséricordieux, le Très Miséricordieux
              </Typography>
            </Box>

            {/* Contract Type Information */}
            {contractTypeInfo && (
              <Box className='contract-type-section' style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd' }}>
                <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold', color: '#2e7d32' }}>
                  Type de Contrat: {contractTypeInfo.name} ({contractTypeInfo.nameAr})
                </Typography>
                <Typography variant="body2" style={{ marginBottom: '10px' }}>
                  <strong>Description:</strong> {contractTypeInfo.description}
                </Typography>
                <Typography variant="body2" style={{ marginBottom: '10px' }}>
                  <strong>Conformité Sharia:</strong> {contractTypeInfo.shariaCompliance}
                </Typography>
                <Typography variant="body2" style={{ marginBottom: '5px' }}>
                  <strong>Caractéristiques clés:</strong>
                </Typography>
                {contractTypeInfo.keyFeatures.map((feature, index) => (
                  <Typography key={index} variant="body2" style={{ marginLeft: '20px' }}>
                    • {feature}
                  </Typography>
                ))}
              </Box>
            )}

            {/* Client Information */}
            <Box display={"flex"} fontStyle="inherit" style={{ marginBottom: '20px' }}>
              <Box width={"40%"}>
                <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Informations Client
                </Typography>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Numéro Client : </Typography>
                  <Typography className='textRight1'><b>{contractData?.form?.NUMCLI}</b></Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Nom Client : </Typography>
                  <Typography className='textRight1'><b>{contractData?.form?.lib_NUMCLI}</b></Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Numéro Dossier : </Typography>
                  <Typography className='textRight1'><b>{contractData?.form?.NUMDOS}</b></Typography>
                </Box>
              </Box>
              
              <Box marginLeft={"10%"} width={"50%"}>
                <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Informations Financement
                </Typography>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Type Prêt : </Typography>
                  <Typography className='textRight1'>
                    <b>{contractData?.form?.TYPEPRET + " - " + contractData?.form?.lib_TYPEPRET}</b>
                  </Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Montant : </Typography>
                  <Typography className='textRight1'>
                    <b>{formatNumber(contractData?.form?.MONTAN) + " XAF"}</b>
                  </Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Taux d'intérêt : </Typography>
                  <Typography className='textRight1'><b>{contractData?.form?.TAUXINT}</b></Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Taux Taxe : </Typography>
                  <Typography className='textRight1'><b>{contractData?.form?.TAUXTAX}</b></Typography>
                </Box>
              </Box>
            </Box>

            {/* Contract Details */}
            <Box style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd' }}>
              <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                Détails du Contrat
              </Typography>
              <Box width={"120%"} display={"flex"}>
                <Typography>Numéro Contrat : </Typography>
                <Typography className='textRight1'><b>{contractData?.form?.NUMCONTRAT || 'N/A'}</b></Typography>
              </Box>
              <Box width={"120%"} display={"flex"}>
                <Typography>Date Signature : </Typography>
                <Typography className='textRight1'>
                  <b>{contractData?.form?.DATESIGNATURE ? formatOrderDate(contractData?.form?.DATESIGNATURE, "JJ-MM-AAAA") : 'N/A'}</b>
                </Typography>
              </Box>
              <Box width={"120%"} display={"flex"}>
                <Typography>Date Début : </Typography>
                <Typography className='textRight1'>
                  <b>{contractData?.form?.DATEDEBUT ? formatOrderDate(contractData?.form?.DATEDEBUT, "JJ-MM-AAAA") : 'N/A'}</b>
                </Typography>
              </Box>
              <Box width={"120%"} display={"flex"}>
                <Typography>Date Fin : </Typography>
                <Typography className='textRight1'>
                  <b>{contractData?.form?.DATEFIN ? formatOrderDate(contractData?.form?.DATEFIN, "JJ-MM-AAAA") : 'N/A'}</b>
                </Typography>
              </Box>
              <Box width={"120%"} display={"flex"}>
                <Typography>Objet du Contrat : </Typography>
                <Typography className='textRight1'><b>{contractData?.form?.OBJETCONTRAT || 'N/A'}</b></Typography>
              </Box>
            </Box>

            {/* Loan Terms */}
            <Box display={"flex"} fontStyle="inherit" style={{ marginBottom: '20px' }}>
              <Box width={"40%"}>
                <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Conditions du Prêt
                </Typography>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Amortissement : </Typography>
                  <Typography className='textRight1'>
                    <b>{contractData?.form?.TYPAMORT + " - " + contractData?.form?.lib_TYPAMORT}</b>
                  </Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Périodicité : </Typography>
                  <Typography className='textRight1'>
                    <b>{contractData?.form?.PERIODIC + " - " + contractData?.form?.lib_PERIODIC}</b>
                  </Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Nombre d'échéance : </Typography>
                  <Typography className='textRight1'>
                    <b>{formatNumber(contractData?.form?.NBRECHE)}</b>
                  </Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Période différé : </Typography>
                  <Typography className='textRight1'>
                    <b>{formatNumber(contractData?.form?.NBPERDIF)}</b>
                  </Typography>
                </Box>
              </Box>
              
              <Box marginLeft={"10%"} width={"50%"}>
                <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                  Épargne et Échéances
                </Typography>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Taux épargne : </Typography>
                  <Typography className='textRight1'><b>{formatNumber(contractData?.form?.TAUXEPAR)}</b></Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Montant épargne : </Typography>
                  <Typography className='textRight1'>
                    <b>{formatNumber(contractData?.form?.MONTEPARG) + " XAF"}</b>
                  </Typography>
                </Box>
                <Box width={"120%"} display={"flex"}>
                  <Typography>Date première échéance : </Typography>
                  <Typography className='textRight1'>
                    <b>{formatOrderDate(contractData?.form?.DAT1ECHE, "JJ-MM-AAAA")}</b>
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Sharia Compliance Statement */}
            <Box style={{ marginBottom: '20px', padding: '15px', border: '2px solid #2e7d32', backgroundColor: '#f1f8e9' }}>
              <Typography variant="h6" style={{ marginBottom: '10px', fontWeight: 'bold', color: '#2e7d32' }}>
                Déclaration de Conformité Sharia
              </Typography>
              <Typography variant="body2">
                Ce contrat de financement est conforme aux principes de la loi islamique (Sharia).
                Il ne contient aucun élément d'intérêt (Riba) et respecte les principes de partage des risques et des profits.
                Les modalités de ce contrat ont été approuvées par le comité de conformité Sharia de l'institution.
              </Typography>
            </Box>

            {/* Signatures */}
            <Box style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #ddd' }}>
              <Box display={"flex"} fontStyle="inherit" justifyContent={"space-between"}>
                <Box width={"45%"} textAlign={"center"}>
                  <Typography variant="body1" style={{ marginBottom: '60px', fontWeight: 'bold' }}>
                    Signature du Client
                  </Typography>
                  <Typography variant="body2">
                    Date: _______________
                  </Typography>
                </Box>
                <Box width={"45%"} textAlign={"center"}>
                  <Typography variant="body1" style={{ marginBottom: '60px', fontWeight: 'bold' }}>
                    Signature de l'Institution
                  </Typography>
                  <Typography variant="body2">
                    Date: _______________
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* Footer */}
            <Box marginTop={"20px"} paddingTop={"10px"} borderTop={"1px solid #ddd"}>
              <Typography variant="body2" align="center">
                Imprimé par {user.coduti} - {user.nomuti} le {new Date(Date.now()).toLocaleDateString(i18next.language)} à {new Date(Date.now()).toLocaleTimeString(i18next.language)}
              </Typography>
            </Box>
          </Box>
        </>
      ) : (
        <PageNotFound 
          message={"Aucun contrat à imprimer"} 
          backLink={"/financement/quard/contrat"} 
          texttButton={"Retour aux Contrats"}
        />
      )}
    </div>
  );
};

export default PrintContratIslamique;
